/**
 * Protocol logic implementation
 * @module Communication
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Peers from "./peers";
import * as Session from "./session";
import createLog from "./log";
import adapter from "webrtc-adapter";
import * as Screenshare from "./screenshare";
var log = createLog("communication");
function catchConnectionError($store, fn) {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fn()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    $store.dispatch("setMinorError", "CONNECTION");
                    console.error("Connection error");
                    console.error(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function onPeerConnectionClosed(_a) {
    var peer = _a.peer;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            log("onPeerConnectionClosed", peer.name);
            return [2 /*return*/];
        });
    });
}
function onPeerConnectionDisconnected(_a) {
    var peer = _a.peer;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            log("onPeerConnectionDisconnected", peer.name, "suspended?", peer.isSuspended);
            peer.isSuspended = true;
            return [2 /*return*/];
        });
    });
}
function onPeerConnectionConnected(_a) {
    var _this = this;
    var $store = _a.$store, peer = _a.peer, session = _a.session;
    log("onPeerConnectionConnected", peer.name);
    peer.isSuspended = false;
    var messageJson = {
        identifier: peer.identifier,
        subaction: "audioMuteStateChanged",
        value: !$store.getters.localAudioEnabled
    };
    Session.send(session, "directMessage", messageJson);
    setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
        var stats, candidatePair, localIP, remoteIP, turnIPs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, peer.connection.getStats(null)];
                case 1:
                    stats = _a.sent();
                    candidatePair = Array.from(stats.values()).find(function (report) {
                        return report.type == "candidate-pair" && report.state == "succeeded" && report.nominated == true;
                    });
                    if (!candidatePair) {
                        log("Undefined candidates");
                        return [2 /*return*/];
                    }
                    localIP = "";
                    remoteIP = "";
                    stats.forEach(function (report) {
                        switch (report.id) {
                            case candidatePair.localCandidateId:
                                localIP = "ipAddress" in report ? report.ipAddress : report.ip;
                                break;
                            case candidatePair.remoteCandidateId:
                                remoteIP = "ipAddress" in report ? report.ipAddress : report.ip;
                                break;
                        }
                    });
                    log("WebRTC connection local_ip: ", localIP, "remote_ip: ", remoteIP);
                    if (!localIP || !remoteIP)
                        return [2 /*return*/];
                    turnIPs = session.iceServers
                        .map(function (iceServer) {
                        if (iceServer.urls.length == 0)
                            return null;
                        var match = /turn:(\d+\.\d+\.\d+\.\d+)/.exec(iceServer.urls[0]);
                        return match === null ? null : match[1];
                    })
                        .filter(function (ip) { return ip != null; });
                    peer.localConnectionType = turnIPs.includes(localIP) ? "turn" : "non-turn";
                    peer.remoteConnectionType = turnIPs.includes(remoteIP) ? "turn" : "non-turn";
                    Session.send(session, "reportConnection", {
                        reconnectCount: peer.reconnectCount++,
                        localType: peer.localConnectionType,
                        remoteType: peer.remoteConnectionType,
                    });
                    return [2 /*return*/];
            }
        });
    }); }, 0);
}
function onPeerConnectionFailed(_a) {
    var $store = _a.$store, peer = _a.peer, session = _a.session;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            log("FAILED connection for", peer.name, peer);
            log("Trying to restart ICE for", peer.name);
            peer.isSuspended = true;
            peer.connection.restartIce();
            return [2 /*return*/];
        });
    });
}
function createPeer($store, session, payload, reconnectCount, suspended) {
    var _this = this;
    if (reconnectCount === void 0) { reconnectCount = 0; }
    if (suspended === void 0) { suspended = false; }
    var peersIdentifier = payload.peersIdentifier, username = payload.username, master = payload.master;
    // Remove and close old master peer when reconnecting Wirecast
    if (master) {
        var wirecastPeer = $store.getters.peers.find(function (item) { return item.master; });
        if (wirecastPeer) {
            wirecastPeer.isSuspended = true;
            Peers.closeConnection(wirecastPeer);
            Peers.remove(wirecastPeer);
            $store.dispatch("removePeer", wirecastPeer);
        }
    }
    var peer = Peers.createConnection(session, peersIdentifier, username, reconnectCount, master, $store.getters.supportMusic, $store.getters.supportSimultaneousScreen);
    peer.isSuspended = suspended;
    var connection = peer.connection;
    log("-> Creating peer for", username, "(", peersIdentifier, ")");
    connection.onconnectionstatechange = function () {
        log(username, "Connection state change to", connection.connectionState);
        // This is a workaround for a Chrome bug,
        // where iceConnectionState does not go to "failed" state.
        // Instead, use connectionState to see if connection has failed.
        // https://bugs.chromium.org/p/chromium/issues/detail?id=935898
        if (adapter.browserDetails.browser === "chrome") {
            var state = connection.connectionState;
            if (state == "failed") {
                onPeerConnectionFailed({ $store: $store, peer: peer, session: session });
            }
        }
    };
    connection.oniceconnectionstatechange = function () {
        var state = connection.iceConnectionState;
        log("-> ICE Connection state change for", username, "to", state);
        var handler = new Map([
            ["closed", onPeerConnectionClosed],
            ["disconnected", onPeerConnectionDisconnected],
            ["connected", onPeerConnectionConnected],
            ["failed", onPeerConnectionFailed],
        ]).get(state);
        if (!handler)
            return;
        handler({ $store: $store, peer: peer, session: session });
    };
    connection.onnegotiationneeded = function () { return catchConnectionError($store, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, Peers.createOffer(session, peer)];
    }); }); }); };
    peer.onReady = function () {
        $store.dispatch("addPeer", peer);
    };
    return peer;
}
function getPeer(peersIdentifier) {
    return Peers.getByIdentifier(peersIdentifier);
}
function onCreateAnswer($socket, $store) {
    var _this = this;
    return function (payload) {
        var peersIdentifier = payload.peersIdentifier;
        var peerCreated = false;
        var peer = getPeer(peersIdentifier);
        if (!peer) {
            peer = createPeer($store, $socket.session, payload);
            peerCreated = true;
        }
        log("-> onCreateAnswer", peer.name);
        catchConnectionError($store, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log("Updating description for peer", peer.name);
                        return [4 /*yield*/, Peers.setRemoteDescription(peer, payload)];
                    case 1:
                        _a.sent();
                        if (peerCreated) {
                            if (peer.master) {
                                Peers.setAnswererTransceiversForMaster(peer, $store.getters.localStream);
                            }
                            else {
                                Peers.setAnswererTransceiversForParticipant(peer, $store.getters.localStream);
                            }
                        }
                        return [4 /*yield*/, Peers.createAnswer($socket, peer)
                            // joining to a session
                        ];
                    case 2:
                        _a.sent();
                        // joining to a session
                        if ($store.getters.appState === "disconnected" || $store.getters.appState === "joining") {
                            log("-> Joined session successfully");
                            $store.dispatch("updateAppState", "connected");
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
}
function onICE() {
    return function (payload) {
        var peer = Peers.getByIdentifier(payload.peersIdentifier);
        if (!peer) {
            console.error("No such peer", payload.peersIdentifier);
            return;
        }
        Peers.createCandidate(peer, payload);
    };
}
function onCreateOffer($socket, $store) {
    return function (payload) {
        var peersIdentifier = payload.peersIdentifier, username = payload.username;
        var peer = getPeer(peersIdentifier);
        if (!peer) {
            peer = createPeer($store, $socket.session, payload);
            Peers.setOffererTransceiversForParticipant(peer, $store.getters.localStream);
        }
        log("-> onCreateOffer", username);
        console.info("### Peers", Peers.getAll());
        peer.name = username;
    };
}
function onGotAnswer($store) {
    var _this = this;
    return function (payload) {
        var peer = Peers.getByIdentifier(payload.peersIdentifier);
        log("Current peers", Peers.getAll());
        log("-> Got answer", peer.name);
        catchConnectionError($store, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, Peers.setRemoteDescription(peer, payload)];
        }); }); });
    };
}
function onGotChatMessages($store) {
    return function (payload) {
        $store.dispatch("gotChatMessages", payload.messages);
    };
}
function onDeletedChatMessage($store) {
    return function (payload) {
        if (payload.all === true) {
            $store.commit("deleteAllChatMessages");
            return;
        }
        $store.commit("deleteChatMessage", payload.index);
    };
}
function onPeerDisconnected($socket, $store) {
    return function (payload) {
        var peer = Peers.getByIdentifier(payload.peersIdentifier);
        if (peer) {
            log("-> Disconnection from", peer.name);
            peer.isSuspended = true;
            Peers.closeConnection(peer);
            Peers.remove(peer);
            $store.dispatch("removePeer", peer);
        }
        if (!$store.getters.peers.length) {
            $store.dispatch("updateAppState", "disconnected");
            Screenshare.stopScreen($store, $socket);
        }
    };
}
function onDisconnect($socket, $store) {
    return function () {
        log("-> Disconnecting");
        Screenshare.stopScreen($store, $socket);
        $store.dispatch("clearPeers");
        $socket.session.socket.close();
        $store.dispatch("updateAppState", "disconnected");
    };
}
function onUpdateSharingStateResponse($store) {
    return function (payload) {
        log("-> UpdateSharingStateResponse. Allowed: ", payload.allowed);
        $store.dispatch("updateSharingScreenAndVideo", payload.allowed);
        if (!payload.allowed) {
            $store.dispatch("setScreenShareError", "SHARING_NOT_ALLOWED");
        }
    };
}
/**
 * Starts listening on given socket (must be SocketPlugin.Socket)
 * @param {SocketPlugin.Socket} $socket - socket to listen to
 * @param {Vuex} $store - vuex store to dispatch actions to
 */
export function establish($socket, $store) {
    var session = $socket.session;
    $socket.on("createAnswer", onCreateAnswer($socket, $store));
    $socket.on("ice", onICE());
    $socket.on("createOffer", onCreateOffer($socket, $store));
    $socket.on("gotAnswer", onGotAnswer($store));
    $socket.on("gotChatMessages", onGotChatMessages($store));
    $socket.on("deletedChatMessage", onDeletedChatMessage($store));
    $socket.on("peerDisconnected", onPeerDisconnected($socket, $store));
    $socket.on("disconnect", onDisconnect($socket, $store));
    $socket.on("updateSharingStateResponse", onUpdateSharingStateResponse($store));
}



//////////////////
// WEBPACK FOOTER
// ./src/communication.ts
// module id = 338
// module chunks = 1